// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"d3640b8d","378":"4240baba","481":"a038290e","541":"d32b9b05","624":"251ff8b1","787":"614fb544"}[chunkId] + ".chunk.js";
};